var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import MuiTooltip from '@mui/material/Tooltip';
import { colorPalette } from '../../colorPalette';
import Fade from '@mui/material/Fade';
import Stack from '@mui/material/Stack';
export const Tooltip = (props) => {
    const { children, tooltipVariants = 'standard', slotProps, title, lazy = false, onOpen, onClose } = props, rest = __rest(props, ["children", "tooltipVariants", "slotProps", "title", "lazy", "onOpen", "onClose"]);
    const [isOpen, setIsOpen] = useState(false);
    const isHypernova = typeof window !== 'undefined' && typeof document !== 'undefined' && !!document.querySelector('[data-hypernova-key]');
    const handleOpen = (event) => {
        if (lazy)
            setIsOpen(true);
        if (onOpen)
            onOpen(event);
    };
    const handleClose = (event) => {
        if (lazy)
            setIsOpen(false);
        if (onClose)
            onClose(event);
    };
    return (React.createElement(MuiTooltip, Object.assign({}, rest, { title: isOpen || !lazy ? (React.createElement(Stack, { sx: { backgroundColor: tooltipVariants === 'outlined' ? 'transparent' : colorPalette.gray700 } }, title)) : null, onOpen: lazy || onOpen ? handleOpen : undefined, onClose: lazy || onClose ? handleClose : undefined, PopperProps: {
            className: '_hy',
            container: () => {
                const id = 'hypernova-class-wrapper';
                const hpernovaClassWrapper = document.getElementById(id);
                if (hpernovaClassWrapper) {
                    return hpernovaClassWrapper;
                }
                const elemDiv = document.createElement('div');
                elemDiv.classList.add('_hy');
                elemDiv.id = id;
                document.body.appendChild(elemDiv);
                return elemDiv;
            },
            sx: Object.assign(Object.assign({ backgroundColor: 'transparent' }, (rest.placement === 'bottom-end' && {
                right: '-7px !important',
            })), { '& .V5Tooltip-tooltip': {
                    marginTop: '16px !important',
                }, display: lazy ? (isOpen ? 'block' : 'none') : 'block' }),
        }, slots: {
            transition: Fade,
        }, slotProps: Object.assign({ transition: {
                timeout: 200,
            }, tooltip: {
                sx: Object.assign(Object.assign({}, (tooltipVariants === 'outlined' && {
                    color: colorPalette.gray800,
                    backgroundColor: 'white',
                    border: `2px solid ${colorPalette.gray400}`,
                })), { maxWidth: 'none', padding: 0, borderRadius: 0 }),
            }, arrow: {
                sx: tooltipVariants === 'outlined'
                    ? {
                        fontSize: '24px',
                        border: 'none',
                        '&::before': {
                            backgroundColor: 'white',
                            boxShadow: `inset 0 0 0px 1px ${colorPalette.gray400}`,
                            border: `1px solid ${colorPalette.gray400}`,
                        },
                        '&.V5Tooltip-arrow::before': {
                            backgroundColor: 'white',
                            boxShadow: `inset 2px 0 0 0 ${colorPalette.gray400}, inset 0 2px 0 0 ${colorPalette.gray400}`,
                            border: 'none !important',
                            height: '14px !important',
                            width: '14px !important',
                            marginTop: '3px !important',
                        },
                        '.V5Tooltip-tooltipPlacementBottom ~ &': Object.assign({}, (rest.placement === 'bottom-end'
                            ? { right: '20px !important' }
                            : {
                                left: '50% !important',
                                transform: 'translateX(50%) !important',
                            })),
                        '.V5Tooltip-popper._hy[data-popper-placement="bottom"] &': Object.assign({}, (isHypernova && {
                            top: '-12px !important',
                        })),
                        '.V5Tooltip-popper._hy[data-popper-placement="bottom-end"] &': Object.assign({}, (isHypernova && {
                            top: '-12px !important',
                        })),
                        '.V5Tooltip-tooltipPlacementTop ~ &': Object.assign({ bottom: '-12px !important' }, (rest.placement === 'bottom-end'
                            ? { right: '20px !important' }
                            : {
                                left: '50% !important',
                                transform: 'translateX(50%) !important',
                            })),
                    }
                    : {
                        fontSize: '20px',
                        '&.V5Tooltip-arrow::before': {
                            height: '14px',
                            width: '14px',
                            marginTop: '3px',
                        },
                        '&.V5Tooltip-arrow': Object.assign({ position: 'absolute !important' }, (rest.placement === 'bottom-end'
                            ? { right: '20px !important' }
                            : {
                                left: '50% !important',
                                transform: 'translateX(50%) !important',
                            })),
                        '._hy &.V5Tooltip-arrow': Object.assign({ position: 'absolute !important' }, (rest.placement === 'bottom-end'
                            ? { right: '20px !important' }
                            : {
                                left: '50% !important',
                                transform: 'translateX(50%) !important',
                            })),
                    },
            } }, slotProps) }), children));
};
